<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      header_show: true
    };
  },
  components: {
  },
  created() {
    this.$router.afterEach((to, from, next) => {

      // window.scrollTo(0, 0);
    });
  },
  methods: {
    public_header: function(bool) {
      this.header_show = bool;
    }
  }
};
</script>

<style>
#app {
  background: #f5f5f5;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  width: 100%;
  margin: 0 auto;
}
html {
  background: #f5f5f5;
}
#class-info .ivu-page-item {
  min-width: 0.52rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue